// src/patterns/TypeSystem.jsx
import React from "react";

// Headlines bleiben bewusst monospace – für Stil und Klarheit
export const Headline = ({ children, underline = false, className = "" }) => (
  <h1
    className={`text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight font-mono text-gray-900 ${className}`}
  >
    {children}
    {underline && (
      <div className="mt-2 w-1/2 sm:w-3/4 lg:w-full mx-auto bg-gray-900 h-1"></div> // Unterstrich für größere Bildschirmgrößen
    )}
  </h1>
);

// Headlines bleiben bewusst monospace – für Stil und Klarheit
export const Headline2 = ({ children, underline = false, className = "" }) => (
  <h2
    className={`text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold tracking-tight font-mono ${className}`}
  >
    {children}
    {underline && (
      <div className="mt-2 w-1/2 sm:w-3/4 lg:w-full mx-auto bg-gray-900 h-1"></div>
    )}
  </h2>
);

// Headlines bleiben bewusst monospace – für Stil und Klarheit
export const Headline3 = ({ children, underline = false, className = "" }) => (
  <h3
    className={`text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold tracking-tight font-mono ${className}`}
  >
    {children}
    {underline && (
      <div className="mt-2 w-1/2 sm:w-3/4 lg:w-full mx-auto bg-gray-900 h-1"></div>
    )}
  </h3>
);

// Subline: lieber Sans-Serif für bessere Lesbarkeit bei Fließtext
export const Subline = ({ children }) => (
  <p className="text-sm sm:text-base text-gray-600 font-sans">{children}</p>
);

// Subline: lieber Sans-Serif für bessere Lesbarkeit bei Fließtext
export const Subline2 = ({ children }) => (
  <p className="text-sm sm:text-base text-gray-500 font-sans">{children}</p>
);

// BodyText: ebenfalls Sans für Lesefluss – aber du kannst bei Bedarf zwischen Varianten wechseln
export const BodyText = ({ children, mono = false }) => (
  <p
    className={`text-base sm:text-lg md:text-xl leading-relaxed ${
      mono ? "font-mono text-black" : "font-sans text-gray-800"
    }`}
  >
    {children}
  </p>
);

